import { Injectable } from '@angular/core';
import { Api } from '../api';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { Observable } from 'rxjs';
import { IDeleteResponse } from '../workspace/interfaces/delete-response.interface';

@Injectable({
  providedIn: 'root'
})
export class CollectionListService extends Api {

  constructor(
    readonly http: HttpClient,
    readonly authService: AuthService
  ) {
    super(http, authService, 'collection');
  }

  get<R>(colName: string) {
    return super.get<R>('/' + colName + '/list');
  }

  getItem<R>(colName: string, id?: string) {
    return super.get<R>('/' + colName + '/list/' + id);
  }

  post<T>(body: T, colName?: string, id?: string) {
    return super.post<T>(body, '/' + colName + '/list/' + id);
  }

  delete(colName: string, id?: string): Observable<IDeleteResponse> {
    return super.delete(colName + '/list/' + id);
  }

  put<T>(body: T, colName?: string) {
    return super.put<T>(body, '/' + colName + '/list');
  }
}
